"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../themes/colors");
exports.Wrapper = styled_components_1.default.div `
  ${({ open }) => (0, styled_components_1.css) `
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    ${open &&
    (0, styled_components_1.css) `
      z-index: 9999;
      &::before {
        z-index: 995;
        position: fixed;
        opacity: 0.3;
        content: '';
        cursor: default;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    `}
  `}
`;
exports.Menu = styled_components_1.default.div `
  ${({ show, theme, width }) => (0, styled_components_1.css) `
    display: ${show ? 'flex' : 'none'};
    cursor: default;
    flex-direction: column;
    width: ${width ? `${width}px` : 'fit-content'};
    position: absolute;
    overflow: hidden;
    box-shadow: 0px 2px 60px rgba(47, 169, 238, 0.4);
    top: ${theme.spacing.unit * 6}px;
    right: 0px;
    border: 1px solid ${colors_1.colors.shade50};
    background: ${colors_1.colors.shade10};
    border-radius: 12px;
    z-index: 999;
  `}
`;
//# sourceMappingURL=styled.js.map